module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-gray page-flex"
  }, [_c('backTitleBar'), _vm._v(" "), _c('div', {
    staticClass: "flex1 posi-rel"
  }, [_c('scroller', {
    ref: "scroller",
    attrs: {
      "on-refresh": _vm.loadNewData,
      "on-infinite": _vm.loadMore
    }
  }, _vm._l((_vm.data), function(item, $index) {
    return _c('div', {
      key: $index,
      staticClass: "list-item click",
      on: {
        "click": function($event) {
          _vm.getScrollerPosition();
          _vm.$router.push({
            name: 'disStockCabinetDetail',
            query: {
              shopId: item.shopId
            }
          })
        }
      }
    }, [_c('div', {
      staticClass: "flex-center"
    }, [_c('div', {
      staticClass: "flex1 fs-32 color-333 flex-center"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v(_vm._s(_vm.equipment_type[item.equipmentType]))]), _vm._v(_vm._s(item.shopName) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "fs-32 color-org ml-20"
    }, [_vm._v("待补货")])]), _vm._v(" "), _c('div', {
      staticClass: "flex fs-28 mt-10"
    }, [_c('div', {
      staticClass: "color-999"
    }, [_vm._v("数量：\n                        "), _c('span', {
      staticClass: "color-333"
    }, [_vm._v(_vm._s(item.lackNum + item.weighLackNum))])]), _vm._v(" "), (item.equipmentType == 'weigh') ? _c('div', {
      staticClass: "color-999 ml-50"
    }, [_vm._v("重量：\n                        "), _c('span', {
      staticClass: "color-333"
    }, [_vm._v(_vm._s(item.weighLackWeight / 1000) + "kg")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "color-999 ml-50"
    }, [_vm._v("种类：\n                        "), _c('span', {
      staticClass: "color-333"
    }, [_vm._v(_vm._s(item.lackItemCount + item.weighLackItemCount + item.weighLackWeightCount))])])])])
  }), 0)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d569f54","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/warning/disStockCabinet.vue
// module id = C76L
// module chunks = 51